import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.concat.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.define-property.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.entries.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import { __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';

function paddingWarning(element) {
  if (process.env.NODE_ENV !== 'production') {
    if (window && 'getComputedStyle' in window) {
      var _a = window.getComputedStyle(element),
        paddingTop = _a.paddingTop,
        paddingBottom = _a.paddingBottom;
      var hasPadding = paddingTop && paddingTop !== '0px' || paddingBottom && paddingBottom !== '0px';
      if (hasPadding) {
        // eslint-disable-next-line no-console
        console.warn('Collapse: Padding applied to the collapse element will cause the animation to break and not perform as expected. To fix, apply equivalent padding to the direct descendent of the collapse element.');
      }
    }
  }
}
function getAutoHeightDuration(height) {
  if (!height || typeof height === 'string') {
    return 0;
  }
  var constant = height / 36;
  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
var Collapse = /** @class */function () {
  function Collapse(params) {
    var _this = this;
    Object.defineProperty(this, "isExpanded", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "options", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "collapseElement", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "isMounted", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "init", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value() {
        var collapseElement = _this.options.getCollapseElement();
        if (_this.collapseElement !== collapseElement) {
          _this.collapseElement = collapseElement;
          if (!_this.isExpanded) {
            _this.setStyles(_this.getCollapsedStyles());
          }
        }
      }
    });
    Object.defineProperty(this, "getCollapsedStyles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value() {
        return {
          display: _this.options.collapsedHeight === 0 ? 'none' : 'block',
          height: "".concat(_this.options.collapsedHeight, "px"),
          overflow: 'hidden'
        };
      }
    });
    Object.defineProperty(this, "setOptions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value(update) {
        var opts = typeof update === 'function' ? update(_this.options) : update;
        Object.entries(opts).forEach(function (_a) {
          var key = _a[0],
            value = _a[1];
          if (typeof value === 'undefined') {
            delete opts[key];
          }
        });
        _this.options = __assign({
          duration: 'auto',
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          expandStyles: {},
          collapseStyles: {},
          hasDisabledAnimation: false,
          collapsedHeight: 0,
          defaultExpanded: false,
          // eslint-disable-next-line no-empty-function
          onExpandedChange: function onExpandedChange() {}
        }, opts);
      }
    });
    Object.defineProperty(this, "setStyles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value(styles) {
        var target = _this.options.getCollapseElement();
        if (!target) {
          return;
        }
        for (var property in styles) {
          var value = styles[property];
          if (value) {
            target.style[property] = value;
          } else {
            target.style.removeProperty(property);
          }
        }
      }
    });
    Object.defineProperty(this, "getTransitionStyles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value(height) {
        if (_this.options.hasDisabledAnimation) {
          return '';
        }
        var duration = _this.options.duration === 'auto' ? getAutoHeightDuration(height) : _this.options.duration;
        return "height ".concat(duration, "ms ").concat(_this.options.easing);
      }
    });
    Object.defineProperty(this, "handleTransitionEnd", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value(e) {
        var _a, _b, _c, _d;
        if (e.propertyName !== 'height') {
          return;
        }
        if (_this.isExpanded) {
          _this.setStyles({
            height: '',
            overflow: '',
            transition: '',
            display: ''
          });
          (_b = (_a = _this.options).onExpandEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        } else {
          _this.setStyles(__assign(__assign({}, _this.getCollapsedStyles()), {
            transition: ''
          }));
          (_d = (_c = _this.options).onCollapseEnd) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
      }
    });
    Object.defineProperty(this, "open", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value() {
        var _a, _b, _c, _d;
        // don't repeat if already open
        if (_this.isExpanded || !_this.isMounted) {
          return;
        }
        var target = _this.options.getCollapseElement();
        if (!target) {
          return;
        }
        _this.isExpanded = true;
        (_b = (_a = _this.options).onExpandedChange) === null || _b === void 0 ? void 0 : _b.call(_a, true);
        (_d = (_c = _this.options).onExpandStart) === null || _d === void 0 ? void 0 : _d.call(_c);
        paddingWarning(target);
        requestAnimationFrame(function () {
          _this.setStyles(__assign(__assign({}, _this.options.expandStyles), {
            display: 'block',
            overflow: 'hidden',
            height: "".concat(_this.options.collapsedHeight, "px")
          }));
          requestAnimationFrame(function () {
            var height = target.scrollHeight;
            // Order important! So setting properties directly
            target.style.transition = _this.getTransitionStyles(height);
            target.style.height = "".concat(height, "px");
          });
        });
      }
    });
    Object.defineProperty(this, "close", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value() {
        var _a, _b, _c, _d;
        if (!_this.isExpanded) {
          return;
        }
        var target = _this.options.getCollapseElement();
        if (!target) {
          return;
        }
        if (!_this.isMounted) {
          _this.init();
          return;
        }
        _this.isExpanded = false;
        (_b = (_a = _this.options).onExpandedChange) === null || _b === void 0 ? void 0 : _b.call(_a, false);
        (_d = (_c = _this.options).onCollapseStart) === null || _d === void 0 ? void 0 : _d.call(_c);
        requestAnimationFrame(function () {
          var height = target.scrollHeight;
          _this.setStyles(__assign(__assign({}, _this.options.collapseStyles), {
            transition: _this.getTransitionStyles(height),
            height: "".concat(height, "px")
          }));
          requestAnimationFrame(function () {
            _this.setStyles({
              height: "".concat(_this.options.collapsedHeight, "px"),
              overflow: 'hidden'
            });
          });
        });
      }
    });
    Object.defineProperty(this, "getCollapse", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: function value() {
        return {
          onTransitionEndHandler: _this.handleTransitionEnd,
          style: {
            boxSizing: 'border-box'
          }
        };
      }
    });
    this.setOptions(params);
    this.isExpanded = Boolean(this.options.defaultExpanded);
    this.init();
    this.isMounted = true;
  }
  return Collapse;
}();

export { Collapse };
